module.exports = __webpack_public_path__ + "img/symptom-check.f31d67ff.svg";